namespace TabAurous.OMS {
    export interface GiftVoucherMasterRow {
        GvId?: number;
        GvType?: number;
        Code?: string;
        Value?: number;
        ProductApplicable?: number;
        MinInvoiceValue?: number;
        PartialRedeem?: boolean;
        Active?: boolean;
        ProdApp?: number[];
        Validity?: number;
        FixedName?: string;
    }

    export namespace GiftVoucherMasterRow {
        export const idProperty = 'GvId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.GiftVoucherMaster';
        export const lookupKey = 'OMS.GiftVoucherMaster';

        export function getLookup(): Q.Lookup<GiftVoucherMasterRow> {
            return Q.getLookup<GiftVoucherMasterRow>('OMS.GiftVoucherMaster');
        }
        export const deletePermission = 'Masters:GiftVoucher:Delete';
        export const insertPermission = 'Masters:GiftVoucher:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:GiftVoucher:Edit';

        export declare const enum Fields {
            GvId = "GvId",
            GvType = "GvType",
            Code = "Code",
            Value = "Value",
            ProductApplicable = "ProductApplicable",
            MinInvoiceValue = "MinInvoiceValue",
            PartialRedeem = "PartialRedeem",
            Active = "Active",
            ProdApp = "ProdApp",
            Validity = "Validity",
            FixedName = "FixedName"
        }
    }
}
